import { render } from "./TaxReport.vue?vue&type=template&id=f55b6ff2"
import script from "./TaxReport.vue?vue&type=script&lang=js"
export * from "./TaxReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__